import type { FC } from 'react';
import { Segmented } from 'antd';
import type { SegmentedProps } from 'antd';

type Props = SegmentedProps;

/** Showcase §4 Segmented（列表 / 甘特图 / 看板） */
export const IpcSegmented: FC<Props> = ({ className, ...rest }) => (
  <Segmented {...rest} className={['ipc-segmented', className].filter(Boolean).join(' ')} />
);
